var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.683 7.871l-4.313 2.37V5.45l1.956 1.081 2.357 1.34zm5.166-3.244s-.15-1.185-.652-1.7c-.602-.67-1.304-.67-1.605-.721C11.335 2 8.025 2 8.025 2s-3.36 0-5.618.155c-.3.051-.953.051-1.605.72-.501.516-.652 1.7-.652 1.7S0 6.017 0 7.408v1.236c0 1.39.15 2.78.15 2.78s.15 1.186.652 1.7c.602.67 1.405.67 1.756.722 1.304.103 5.417.154 5.417.154s3.36 0 5.617-.154c.301-.052.953-.052 1.605-.721.502-.515.652-1.7.652-1.7s.151-1.39.151-2.78V7.407c0-1.39-.151-2.781-.151-2.781z","fillRule":"evenodd"}));
}

Youtube.defaultProps = {"width":"16","height":"16"};

module.exports = Youtube;

Youtube.default = Youtube;
